import { ChoiceButton } from '@components/ui';
import { ISelectOption } from '@legalosApi/types/ISelectOption';
import React from 'react';

export interface Props {
  disabled?: boolean;
  onClick: () => void;
  option: ISelectOption;
  shortcutKey: string;
  isSelected?: boolean;
  isHighlighted?: boolean;
}

export function Option({ disabled, onClick, option, shortcutKey, isSelected, isHighlighted }: Props) {
  const [didTrigger, setDidTriggered] = React.useState(false);

  function onTrigger() {
    if (disabled || didTrigger) return;
    setDidTriggered(true);
    onClick();
  }

  React.useEffect(() => {
    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.key === shortcutKey) onTrigger();
    };
    window.addEventListener('keyup', handleKeyUp);
    return () => window.removeEventListener('keyup', handleKeyUp);
  }, [disabled, didTrigger, shortcutKey]);

  return (
    <ChoiceButton
      disabled={disabled}
      key={option.value}
      onClick={onTrigger}
      isSelected={isSelected}
      isHighlighted={isHighlighted}
      spinner={didTrigger}
    >
      <div className="grid items-center grid-cols-[24px_1fr_24px]">
        <span />
        <span className="text-center">{option.label}</span>
        <span className="dtUiShortcut__hint">
          <span className="key">{shortcutKey}</span>
        </span>
      </div>
    </ChoiceButton>
  );
}
